//@ts-check
// @ts-ignore
define("SDB.FindPerfectFit.Model", [
  "SCModel",
  "Utils",
  "Singleton",
  "underscore",
], function (SCModelComponent, Utils, Singleton, _) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  function SDBFindPerfectFit() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        // @ts-ignore
        getExtensionAssetsPath(
          "Modules/SDBFindPerfectFit/SuiteScript2/SDB.FindPerfectFit.Service.ss"
        ),
        true
      );
    };
  }

  SDBFindPerfectFit.prototype = Object.create(SCModel.prototype);
  SDBFindPerfectFit.prototype.constructor = SDBFindPerfectFit;

  return _.extend(SDBFindPerfectFit, Singleton);
});
